<template>
    <div class="newform-page" v-loading="loading">
       <el-divider>订单详情</el-divider>
        <div class="newform-btn">
          <el-button   plain size="small" @click="back">返回</el-button>
        </div>
        <div class="title" style="padding-left:56px;">车型&基础参数</div>
        <div class="my-form form">
            <el-form :disabled="true" size="small" :inline="true" ref="form" :model="basicForm">
              <el-form-item label="批次号：">
                <span>{{pch}}</span>
              </el-form-item>
              <el-form-item label="所属大区：">
                <span>{{areaData}}</span>
              </el-form-item>
              <el-form-item label="国家：">
                <span>{{countryData}}</span>
              </el-form-item>
              <br/>
              <el-form-item  class="zq"   size="small" v-for="(domain, index) in basicForm.types"
                
                :key="domain.key"
                :prop="domain.value">
                <el-form-item required  :label="'车型' + (index+1)">
                
                <el-select v-model="domain.dataManageCarModelId" placeholder=" " filterable clearable>
                    <el-option
                      v-for="(item,i) in options"
                      :key="i"
                      :label="item.content"
                      :value="item.dataManageCarModelId">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item  label="数量" required>
                <el-input  v-model="domain.quantity">
                  
                </el-input>
                
              </el-form-item>
              <el-form-item  >
                <span>台</span>
              </el-form-item>
              <el-form-item  required label="销售单价" >
                <el-input v-model="domain.salesUnitPrice" placeholder=""></el-input>
              </el-form-item>
              <el-form-item  >
                <span>元</span>
              </el-form-item>
              <el-form-item  required label="成本" >
                <el-input v-model="domain.cost" placeholder=""></el-input>
              </el-form-item>
              <el-form-item  >
                <span>元</span>
              </el-form-item>
              <el-form-item required label="物流费用" >
                <el-input v-model="domain.logisticsExpenses" placeholder=""></el-input>
              </el-form-item>
              <el-form-item  >
                <span>元</span>
              </el-form-item>
              <el-form-item required label="关税" >
                <el-input v-model="domain.tariff" placeholder=""></el-input>
              </el-form-item>
              <el-form-item  >
                <span>元</span>
              </el-form-item>
             
               <br/>
              </el-form-item>
              
              <br/>           
            </el-form>
       
            <div class="title">周期参数</div>
              <div class=" flex">
                <el-form :disabled="true" size="small" :inline="true" :model="basicForm" class="demo-form-inline">
                  <el-form-item  required label="订单日期">
                     <el-date-picker
                        v-model="basicForm.orderDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        >
                      </el-date-picker>
                  </el-form-item>
                  <br/>
                  <el-form-item class="zq">
                    <el-form-item  required label="生产周期">
                      <el-input v-model="basicForm.productionCycle" placeholder=""></el-input>
                    
                    </el-form-item>
                    <el-form-item  >
                      <span>天</span>
                    </el-form-item>
                    <el-form-item  required label="发运周期">
                      <el-input v-model="basicForm.shippingCycle" placeholder=""></el-input>
                    </el-form-item>
                     <el-form-item  >
                      <span>天</span>
                    </el-form-item>
                    <el-form-item required label="到岸周期">
                      <el-input v-model="basicForm.arrivalCycle" placeholder=""></el-input>
                    </el-form-item>
                     <el-form-item  >
                      <span>天</span>
                    </el-form-item>
                    <el-form-item required label="销售周期">
                      <el-input v-model="basicForm.salesCycle" placeholder=""></el-input>
                    </el-form-item>
                     <el-form-item  >
                      <span>天</span>
                    </el-form-item>
                    <el-form-item required label="还信保周期">
                      <el-input v-model="basicForm.creditInsuranceRepaymentCycle" placeholder=""></el-input>
                    </el-form-item>
                     <el-form-item  >
                      <span>天</span>
                    </el-form-item>
                    <el-form-item required label="关税支付周期">
                      <el-input v-model="basicForm.tariffPaymentCycle" placeholder=""></el-input>
                    </el-form-item>
                     <el-form-item  >
                      <span>天</span>
                    </el-form-item>
                    <el-form-item required label="运费支付周期">
                      <el-input v-model="basicForm.freightPaymentCycle" placeholder=""></el-input>
                    </el-form-item>
                     <el-form-item  >
                      <span>天</span>
                    </el-form-item>
                    </el-form-item>

                </el-form>
              </div>
            <div class="title">付款参数</div>
              <div class=" flex">
                <el-form :disabled="true" size="small" :inline="true" :model="basicForm" class="demo-form-inline">
                  <el-form-item  required label="付款类型">
                      <el-radio-group v-model="basicForm.paymentTypeId">
                        <el-radio  v-for="(item,i) in options3"
                      :key="i"
                      :label="item.dataManagePaymentTypeId"
                       >{{item.content }}</el-radio>
                        
                      </el-radio-group>
                  </el-form-item>
                  <br/>
                  <el-form-item   size="small" v-for="(domain, index) in basicForm.pays" :key="domain.key" :prop="domain.bl">
                    <el-form-item required   :label="'笔数:第 '+(index+1)+' 笔'">
                    </el-form-item>
                    <el-form-item class="zq"  required label="比例">
                      <el-input v-model="domain.ratio" placeholder=""></el-input>
                    
                    </el-form-item>
                    <el-form-item  >
                      <span>%</span>
                    </el-form-item>
                    <el-form-item  required label="方式">
                      <el-select v-model="domain.dataManagePaymentMethodId" placeholder="请选择" filterable clearable>
                        <el-option
                          v-for="(item,i) in options1"
                          :key="i"
                          :label="item.content"
                          :value="item.dataManagePaymentMethodId">
                        </el-option>
                      </el-select>
                    
                    </el-form-item>
                    <el-form-item  required label="节点">
                      <el-select v-model="domain.node" placeholder="请选择" filterable clearable>
                        <el-option
                          v-for="item in options2"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    
                    </el-form-item>
                    
                   <br/>
                    </el-form-item>
                </el-form>
              </div>
        </div>
    </div>
</template>
<script>
import {  getSession } from '@/util/localStor'
import { orderQuery } from '@/api/zd'
// import { basicLoad } from '@/api/zd'
export default {
    data(){
        return{
           pch:'',
          areaData:'',
          countryData:'',
          loading:false,
            options: [],
            options1: [],
            options3: [],
            options2: [
              {
                label:'生产周期(截止日)',
                value:0
              },
              {
                label:'发运周期(截止日)',
                value:1
              },
              {
                label:'到岸周期(截止日)',
                value:2
              },
              {
                label:'销售周期(截止日)',
                value:3
              },
              {
                label:'还信宝周期(截止日)',
                value:4
              },
              {
                label:'关税支付周期(截止日)',
                value:5
              },
              {
                label:'运费支付周期(截止日)',
                value:6
              },
            ],
            dialogShow:false,
            basicForm: {
                user:'',
                name: '',
                region: '',
                paymentTypeId:'',
                orderDate: '',
                productionCycle: '',
                shippingCycle:'',
                arrivalCycle:'',
                salesCycle:'',
                creditInsuranceRepaymentCycle:'',
                tariffPaymentCycle:'',
                freightPaymentCycle:'',
                
                types: [{dataManageCarModelId:'',quantity:'',salesUnitPrice:'',cost:'',logisticsExpenses:'',tariff:''}],
                pays:[{dataManagePaymentMethodId:'',node:'',ratio:''}],
            },
        }
    },
    mounted(){
      this.pch = sessionStorage.getItem('pch')
      if(sessionStorage.getItem('areaInfo')){
        let string = sessionStorage.getItem('areaInfo')
        this.areaData = string.split("——")[0]
        this.countryData = string.split("——")[1]
      }
     
      // this.getBasicData()
      this.judgeBasic()
      this.getDetail()
    },
    beforeDestroy(){
      sessionStorage.removeItem('pch')
    },
    methods:{
            async getDetail(){
        this.loading = true
        let query = {
          data:{
            dataManageOrderId:sessionStorage.getItem('orderId')
          }
          
        }
        const res = await orderQuery(query)
        if(res.status==0){
          this.basicForm.orderDate = res.data.dataManageOrder.orderDate
          this.basicForm.paymentTypeId = res.data.dataManageOrder.paymentTypeId
          this.basicForm.types = res.data.carModelListParam
          this.basicForm.pays = res.data.paymentParam
          this.basicForm.productionCycle=res.data.dataManageOrder.productionCycle
          this.basicForm.shippingCycle=res.data.dataManageOrder.shippingCycle
          this.basicForm.arrivalCycle=res.data.dataManageOrder.arrivalCycle
          this.basicForm.salesCycle=res.data.dataManageOrder.salesCycle
          this.basicForm.creditInsuranceRepaymentCycle=res.data.dataManageOrder.creditInsuranceRepaymentCycle
          this.basicForm.tariffPaymentCycle=res.data.dataManageOrder.tariffPaymentCycle
          this.basicForm.freightPaymentCycle=res.data.dataManageOrder.freightPaymentCycle
        
          this.loading = false
         
        }
       
      },
      judgeBasic(){
        if(Object.keys(getSession('zdCar')).length>0){
          this.options = getSession('zdCar')
        }
        if(Object.keys(getSession('zdPayType')).length>0){
          this.options3 = getSession('zdPayType')
        }
        if(Object.keys(getSession('zdPayWay')).length>0){
          this.options1 = getSession('zdPayWay')
        }
      },
        back(){
          this.$router.go(-1)
        },
    
     
        
    }
}
</script>
<style lang="scss" scoped>
.newform-page{
   box-sizing: border-box;
   position: relative;
    .newform-btn{
        width: 100px;
        height: 80px;
        position: absolute;
        right: 50px;
        top: 30px;
    }
    .title{
        font-size: 18px;
        font-weight: bold;
        line-height: 40px;
    }
    .zq{
      ::v-deep .el-input__inner{
        width: 80px;
        height: 30px;
      }
    }
    
    ::v-deep .el-divider--horizontal{
      height: 2px;
      margin: 24px auto;
      width: 90%;
    }
    ::v-deep .el-divider{
      background: #222;
    }
    ::v-deep .el-divider__text{
      font-weight: bold;
      font-size: 16px;
    }
    .my-form{
      padding-left: 56px;
    }
}
</style>